/**
 * Generate initials from a name or source string
 * Examples:
 * - "Claudia Smith" -> "CS"
 * - "NHS Staff" -> "NS"
 * - "Parent" -> "P"
 */
export function getInitials(name: string): string {
  if (!name) return "?";
  
  const words = name.trim().split(/\s+/);
  
  if (words.length >= 2) {
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }
  
  return words[0].substring(0, 2).toUpperCase();
}
